module.exports = __webpack_public_path__ + "img/male_boy_person_people_avatar_icon_159358.aafc2181.png";